// extracted by mini-css-extract-plugin
export var container = "_ho-0";
export var content = "_ho-3";
export var customerTitle = "_ho-4";
export var empty = "_ho-5";
export var gray = "_ho-6";
export var header = "_ho-7";
export var info = "_ho-8";
export var loading = "_ho-2";
export var loadingCard = "_ho-9";
export var oneLine = "_ho-a";
export var personName = "_ho-e";
export var pillContainer = "_ho-b";
export var selected = "_ho-1";
export var text = "_ho-c";
export var twoLines = "_ho-d";
export var unread = "_ho-f";
export var unreadIndicator = "_ho-g";